import vmClient from 'app/services/vmClient';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';
import { Text, IText } from 'app/constants/schemas/Text';
import { ParagraphSentenceQuiz, IParagraphSentenceQuiz } from 'app/constants/schemas/ParagraphSentenceQuiz';
import { Sound, ISound } from 'app/constants/schemas/Sound';

export interface IParagraphSentence extends IEntity {
  attributes: {
    id: EntityStringId;
    cohortId: string | null;
  };
  associations: {
    ParagraphSentenceQuiz: IParagraphSentenceQuiz[];
    text: IText;
    sound: ISound | null;
  };
}

export type ParagraphSentence = Entity<IParagraphSentence>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ParagraphSentence: IEntityType<IParagraphSentence> = vmClient.defineClass({
  typeName: 'ParagraphSentence',
  version: 4,
  lockable: true,
  persisted: true,
  attributes: {
    cohortId: 'string',
  },
  associations: {
    paragraphSentenceQuizzes: {
      collection: true,
      type: ParagraphSentenceQuiz,
    },
    text: {
      type: Text,
      notNull: true,
    },
    sound: Sound,
  },
});
